import { css, cx } from '@eti/styles';
import { breakpoints } from '@etg/wings';
import { readMoreTextBase } from '../../main-layout/read-more/styles';
export const viReadMoreGrid = css`
  display: grid;

  .text {
    grid-area: 2 / 1 / 3 / 2;
  }

  .children {
    display: contents;
  }

  .children > * {
    grid-area: 1 / 1 / 2 / 2;
    margin-bottom: 8px;
  }
`;
export const viText = iconContent => cx(readMoreTextBase(iconContent), css`
      margin-top: 16px;
      padding-inline-start: 8px;

      > *:not(:last-child) {
        &:not(a) {
          margin-bottom: 16px;
        }
      }

      ul {
        li {
          display: flex;
          &::before {
            display: flex;
          }
        }
      }

      a {
        display: block;
        width: fit-content;

        &::after {
          margin-inline-start: 2px;
          position: absolute;
          top: -1px;
        }
      }
    `);
export const viHeaderGrid = css`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: repeat(2, auto);

  @media (max-width: ${breakpoints._768}) {
    grid-template-columns: calc(2rem + 8px) 1fr;
  }

  .children {
    display: flex;
    gap: 8px;
    grid-area: 1 / 1 / 2 / 3;
    margin-bottom: 8px;
  }

  .title {
    grid-area: 2 / 1 / 3 / 3;

    @media (max-width: ${breakpoints._768}) {
      grid-area: 2 / 2 / 3 / 3;
    }
  }

  .pictogram {
    display: none;

    @media (max-width: ${breakpoints._768}) {
      display: grid;
      grid-area: 2 / 1 / 3 / 2;
      height: 2rem;
      margin-inline-end: 8px;
      margin-top: 2px;
      width: 2rem;
    }
  }
`;
//# sourceMappingURL=styles.js.map